module.exports = __webpack_public_path__ + "static/media/azubu-booth.46cf056d.png";